type PaymentGooglePayConfigType = {
    stripe: {
        publishableKey: string;
        version: string;
    };
    merchantId: string;
    merchantName: string;
    totalPrice: string;
    platform: 'mobile' | 'desktop';
};

/**
 * Config for Google Pay
 */
export const paymentGooglePayConfig = ({
    merchantId,
    merchantName,
    platform,
    stripe,
    totalPrice,
}: PaymentGooglePayConfigType): google.payments.api.PaymentDataRequest => {
    return {
        allowedPaymentMethods: [
            {
                parameters: {
                    allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                    allowedCardNetworks: ['MASTERCARD', 'VISA'],
                },
                tokenizationSpecification: {
                    parameters: {
                        gateway: 'stripe',
                        'stripe:publishableKey': stripe.publishableKey,
                        'stripe:version': stripe.version,
                    },
                    type: 'PAYMENT_GATEWAY',
                },
                type: 'CARD',
            },
        ],
        apiVersion: 2,
        apiVersionMinor: 0,
        merchantInfo: {
            merchantId,
            merchantName,
        },
        transactionInfo: {
            currencyCode: 'USD',
            totalPrice,
            totalPriceLabel: 'Total',
            totalPriceStatus: 'FINAL',
            ...(platform === 'mobile' ? {countryCode: 'US'} : {}),
        },
    };
};
